import {
  FORM_VALID_MESSAGE,
  PHONES_PREFIX_THREE,
  PHONES_PREFIX_FORE,
  PHONES_PREFIX_REPLACE,
  THREE_REG
} from "./constant";
import {BASE_URL} from "./api";

export function isMobile() {
  const matcher = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  if (window.navigator.userAgent.match(matcher)) {
    return true
  } else {
    return false
  }
}

/**
 *
 * @param type 1: 注册， 2：登陆
 * @param data Form表单
 * @returns {} 错误信息
 */
export function validForm(type, data) {

  console.log('我擦为啥值是一样的。。。', type, data)

  let title = type == 1 ? FORM_VALID_MESSAGE.registerFailTitle : FORM_VALID_MESSAGE.loginFailTitle
  let errorMsg = {};
  if (type == 2) {
    if (!data.userName || !data.password) {
      errorMsg.title = FORM_VALID_MESSAGE.loginFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.emptyMsg
      return errorMsg
    }
  } else {
    if (!data.userName || !data.password || !data.phone || !data.email) {
      errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.emptyMsg
      return errorMsg
    }
  }
  if (data.userName.length < 4 || data.userName.length > 20) {
    errorMsg.title = title
    errorMsg.content = FORM_VALID_MESSAGE.usernameFormatErr
    return errorMsg
  }
  if (data.password.length < 6 || data.password.length > 15) {
    errorMsg.title = title
    errorMsg.content = FORM_VALID_MESSAGE.passwordMsg
    return errorMsg
  }
  if (type === 1 && !validPhone(data.phone)) {
    errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
    errorMsg.content = FORM_VALID_MESSAGE.phoneInvalid
    return errorMsg
  }
  if (type == 1 && !validEmail(data.email)) {
    errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
    errorMsg.content = FORM_VALID_MESSAGE.emailInvalid
    return errorMsg
  }
  if (type == 1 && ['gmail.com', 'yahoo.com'].indexOf(data.email.split('@')[1].toLowerCase()) == -1) {
    errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
    errorMsg.content = FORM_VALID_MESSAGE.emailFormatErr
    return errorMsg
  }
  return errorMsg
}
/**
 *
 * @param type 1: 注册， 2：登陆
 * @param data Form表单
 */
export function newValidForm(type, data) {
    let title = type == 1 ? FORM_VALID_MESSAGE.registerFailTitle : FORM_VALID_MESSAGE.loginFailTitle
    console.log('我擦为啥值是一样的。。。新的', type, data)
    let errorMsg = {};

    if (!data.userName){
        errorMsg.title = title
        errorMsg.userName = 'Vui lòng nhập tên đăng nhập'
    } else if (data.userName.length < 4 || data.userName.length > 20) {
        errorMsg.title = title
        errorMsg.userName = 'Tên đăng nhập phải từ 4 -20 ký tự'
    }



    if (!data.password){
      errorMsg.title = title
       errorMsg.content = 'Vui lòng nhập mật khẩu'
    } else if (data.password.length < 6 || data.password.length > 15) {
      errorMsg.title = title
      errorMsg.content= 'Mật khẩu phải từ 6 đến 15 ký tự'
    }

    if (type === 1) {
        if (!data.checkPass){
          errorMsg.title = title
          errorMsg.content = 'Vui lòng nhập mật khẩu'
        } else if (data.password !== data.checkPass) {
          errorMsg.title = title
          errorMsg.content = 'Mật khẩu không trùng khớp'
        }

        if (!data.verificationCode){
          errorMsg.title = title
          errorMsg.content = 'Vui lòng nhập mã xác minh'
        } else if (data.verificationCode.length !== 4) {
          errorMsg.title = title
          errorMsg.content = 'Mã xác minh không chính xác'
        }
    }

    return errorMsg
}




function validEmail(email) {
  if (email.indexOf('@') == -1) return false
  let temp = email.split('@')
  if (temp[0] == '' || temp[1] == '') return false
  if (temp[1].indexOf('.') == -1) return false
  if (temp[1].split('.')[0] == ''
    || temp[1].split('.')[1] == ''
    || temp[1].split('.')[0].length < 1
    || temp[1].split('.')[1].length < 2) {
    return false
  }
  return true
}

function validPhone(phone) {
  return THREE_REG.test(phone)
}

export function endsWithSlash(str) {
  if(str.endsWith('/')){
    return str
  }
  return str+'/'
}

/**
 * 跳转平台
 * @param username
 * @param password
 */
export function encodePlatformUrl(username, password,url='') {
  let baseUrl=BASE_URL
  if(url!=''){
    // baseUrl=endsWithSlash(url);
    baseUrl='https://8dn195.com/'
  }
    baseUrl='https://8dn195.com/'
//  跳转平台 h5 要跳转login
  if(isMobile()){
    return `${baseUrl}login?params=${window.btoa(JSON.stringify({
      username: username,
      password: password.replace(/\s+/g, "")
    }))}`
  }
  return `${baseUrl}?params=${window.btoa(JSON.stringify({
    username: username,
    password: password.replace(/\s+/g, "")
  }))}`
}

/**
 * 校验表单邮箱
 * @param rule
 * @param value
 * @param callback
 */
export function validateEmail(rule, value, callback) {
  if ((value !== "" && !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) ||
    String(value).toLowerCase().indexOf("icloud") > -1) {
    callback(new Error(FORM_VALID_MESSAGE.emailInvalid))
  } else {
    callback();
  }
}
/**
 * 校验表单电话号码
 * @param rule
 * @param value
 * @param callback
 */
export function validatePhone(rule, value, callback) {
  const reg = /^\d{10,11}$/
  if (!reg.test(value)) {
    callback(new Error(FORM_VALID_MESSAGE.phoneInvalid))
  } else if (value.length == 10 && !THREE_REG.test(value)) {
    callback(new Error(FORM_VALID_MESSAGE.phoneInvalid))
  } else if (value.length == 11 && !PHONES_PREFIX_FORE.includes(value.substr(0, 4))) {
    callback(new Error(FORM_VALID_MESSAGE.phoneInvalid))
  } else {
    callback()
  }
}

export function replacePhonePrefix(phone) {
  if (phone.length == 11 && PHONES_PREFIX_FORE.includes(phone.substr(0, 4))) {
    return `${PHONES_PREFIX_REPLACE[phone.substr(0, 4)]}${phone.substr(4)}`
  } else {
    return phone
  }
}





// WEBPACK FOOTER //
// ./src/utils/tools.js